import { render } from "./02_HeroSection.vue?vue&type=template&id=445ec812&scoped=true"
import script from "./02_HeroSection.vue?vue&type=script&lang=js"
export * from "./02_HeroSection.vue?vue&type=script&lang=js"

import "./02_HeroSection.vue?vue&type=style&index=0&id=445ec812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445ec812"]])

export default __exports__